"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCrossModuleComponentData = getCrossModuleComponentData;
exports.getEpharmacyBanners = getEpharmacyBanners;
exports.getEssentialProducts = getEssentialProducts;
exports.getHealthConditions = getHealthConditions;
exports.getLandingPageData = getLandingPageData;
exports.getLoyaliticspoints = getLoyaliticspoints;
exports.getPharmacyBanner = getPharmacyBanner;
exports.getPharmacyBannersBottom = getPharmacyBannersBottom;
exports.getPharmacyBannersMiddle = getPharmacyBannersMiddle;
exports.getPharmacyCategoriesMenu = getPharmacyCategoriesMenu;
exports.getPharmacyShopByBrand = getPharmacyShopByBrand;
exports.getPopularCategories = getPopularCategories;
exports.getTopDeals = getTopDeals;
exports.getTrendingProducts = getTrendingProducts;
var _genericFetch = _interopRequireWildcard(require("../../../common/api/genericFetch"));
var _ApiConst = require("../../../common/utils/ApiConst");
var _utils = require("../../../common/utils/utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// import { apiCall } from '../../../common/api/api';

function getPopularCategories(tokenData) {
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.POPULAR_CATEGORIES;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getEssentialProducts(params, tokenData) {
  const queryString = (0, _utils.getQuery)(params);
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.ESSENTIAL_PRODUCT + queryString;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getTopDeals(params, tokenData) {
  const queryString = (0, _utils.getQuery)(params);
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.TOP_DEALS + queryString;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getTrendingProducts(params, tokenData) {
  const queryString = (0, _utils.getQuery)(params);
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.TRENDING_PRODUCTS + queryString;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getHealthConditions(tokenData) {
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.HEALTH_CONDITIONS;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getPharmacyBanner(tokenData) {
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.HOME_BANNER_TOP;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getLoyaliticspoints(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.CHECK_LOYALTICS_CUSTOMER}?patientId=${requestParams.patientId}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getPharmacyBannersMiddle(tokenData) {
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.GET_PHARMACY_BANNERS_MIDDLE;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getPharmacyBannersBottom(tokenData) {
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.GET_PHARMACY_BANNERS_BOTTOM;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getPharmacyShopByBrand(tokenData) {
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.GET_PHARMACY_SHOP_BY_BRAND;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getEpharmacyBanners(bannerId, tokenData) {
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.PHARMACY_BANNER + bannerId;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getPharmacyCategoriesMenu(tokenData) {
  // const apiEndPoint = BASE_URL + PHARMACY_CATEGORIES_MENU;
  const apiEndPoint = _ApiConst.PHARMACY_CATEGORIES_MENU;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getLandingPageData(slug, tokenData) {
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.GET_LANDING_PAGE_DATA + slug;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getCrossModuleComponentData(params, tokenData) {
  const queryString = (0, _utils.getQuery)(params);
  const apiEndPoint = _ApiConst.CROSS_MODULE_COMPONENT + queryString;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}